import { Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface MotivationProps {
  motivation: string | null;
}

/**
 * This component displays the hobbies of an applicant.
 * @param hobbies The hobbies of an applicant
 * @returns The hobbies of an applicant.
 */
const Motivation = ({ motivation }: MotivationProps) => {
  return (
    <ProfileDataCard title="Motivation">
      <Typography>{motivation}</Typography>
    </ProfileDataCard>
  );
};

export default Motivation;
